import {Message} from 'view-design';

export default {
  showTipInfo(text, options = {}) //失敗的提示
  {
    Message.destroy();
    Message.warning({
      content: text,
      duration: options.duration || 3
    });
  },
  showSuccess(text, options = {}) //成功的提示
  {
    Message.destroy();
    Message.success({
      content: text,
      duration: options.duration || 3
    });
  },
  formatDate(datetime) {
    if (!datetime) return '';
    let dateTime = new Date(datetime);
    let year = dateTime.getFullYear();
    let month = dateTime.getMonth() + 1;
    let date = dateTime.getDate();
    let hour = dateTime.getHours();
    let minute = dateTime.getMinutes();
    let second = dateTime.getSeconds();
    return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)}`;
  },
  formatNum(num) {
    return num < 10 ? '0' + num : num;
  },
  compareDate(endTime, startTime) {
    var oDate1 = new Date(endTime).getTime();
    var oDate2 = new Date(startTime).getTime();
    if (oDate1 > oDate2) {
      return 1;
    } else if (oDate1 == oDate2) {
      return 0;
    } else {
      return -1;
    }
  },
  filterParams(str) //轉化為url參數
  {
    str += '';
    str = str.replace(/%/g, '%25');
    str = str.replace(/\+/g, '%2B');
    str = str.replace(/ /g, '%20');
    str = str.replace(/\//g, '%2F');
    str = str.replace(/\?/g, '%3F');
    str = str.replace(/&/g, '%26');
    str = str.replace(/\=/g, '%3D');
    str = str.replace(/#/g, '%23');
    return str;
  },
  formateObjToParamStr(paramObj) {
    const sdata = [];
    for (let attr in paramObj) {
      sdata.push(`${attr}=${this.filterParams(paramObj[attr])}`);
    }
    return sdata.join('&');
  },
  differenttDate(startTime, endTime) {
    var dateStart = new Date(startTime);
    var dateEnd = new Date(endTime);
    var difValue = (dateEnd - dateStart) / (1000 * 60 * 60 * 24);
    return difValue;
  },
  throttle(fn, wait = 1500) {
    var pre = Date.now();
    return function () {
      var context = this;
      var args = arguments;
      var now = Date.now();
      if (now - pre >= wait) {
        fn.apply(context, args);
        pre = Date.now();
      }
    }
  },
  debounce(fn, wait = 500, immediate = false) {
    let timer;
    return function () {
      if (timer) clearTimeout(timer);
      if (immediate) {
        let callNow = !timer;
        timer = setTimeout(() => {
          timer = null;
        }, wait);
        if (callNow) {
          fn.apply(this, arguments);
        }
      } else {
        timer = setTimeout(() => {
          fn.apply(this, arguments);
        }, wait);
      }
    }

  }
};
